import styled from 'styled-components';

export const Segmented = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  background: ${(props) => (props.$onDark ? 'rgba(255, 255, 255, 0.08)' : 'var(--cp-surface-alt, #fafbfc)')};
  border: 1px solid ${(props) => (props.$onDark ? 'rgba(255, 255, 255, 0.12)' : 'var(--cp-border, #e5e7eb)')};
`;

export const Option = styled.button`
  appearance: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  padding: 6px 12px;
  border-radius: 999px;
  white-space: nowrap;
  transition: color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
  color: ${(props) => (props.$onDark ? 'rgba(242, 246, 243, 0.7)' : 'var(--cp-text-secondary, #5b6770)')};
  background: transparent;

  &:hover {
    color: var(--cp-green, #47b972);
  }

  ${(props) =>
    props.$active &&
    `
    color: #fff;
    background: linear-gradient(90deg, #5cc98a 0%, #47b972 100%);
    box-shadow: 0 2px 10px rgba(71, 185, 114, 0.35);
    &:hover { color: #fff; }
  `}
`;
